import React from "react";
import { cn } from "../../Utils/helper";

const ProgressDot = ({
  index,
  currentStep,
  isReviewed = false,
  isErrorStep = false,
  hasAnswer = false,
  onClick,
  isActive,
}) => {
  // const stepNumber = index + 1;
  const isCurrent = isActive;

  let dotClass = "w-2 h-2 rounded-full transition-all duration-300";
  let dotColor = "bg-[#E9E6E4]";

  if (isReviewed && isErrorStep) {
    dotColor = "bg-[#EF4056]";
  } else if (hasAnswer) {
    // dotColor = "bg-[#08B89D]";
  }

  if (isCurrent) {
    dotClass = "w-3 h-3 rounded-full transition-all duration-300";
    if (!isErrorStep && !hasAnswer) {
      // dotColor = "bg-[#253FF6]";
      dotColor = "bg-[#A0A0A0]";
    } else if (hasAnswer) {
      dotColor = "bg-[#A0A0A0]";
    }
  }

  return (
    <div
      className="flex items-center justify-center p-1"
      onClick={onClick}
    >
      <div className={cn(dotClass, dotColor)} />
    </div>
  );
};

export default ProgressDot;
